import { CubeCamera, CubeReflectionMapping, CubeRefractionMapping, LinearMipmapLinearFilter, PMREMGenerator, SRGBColorSpace, WebGLCubeRenderTarget } from "three";
import { mainScene } from "../mainScene";
import { cubeMapRenderer, renderer } from "../RendererGlobals";
import { CameraLayers, isPowerOfTwo, MulticastDelegate1 } from "flavr-common";
class EnvironmentSceneService {
    constructor() {
        this.hdrEnvironmentActive = false;
        this.onHdrEnvironmentActiveChanged = new MulticastDelegate1();
    }
    isHdrEnvironmentActive() {
        return this.hdrEnvironmentActive;
    }
    setHdrEnvironmentActive(active) {
        if (this.hdrEnvironmentActive === active)
            return;
        this.hdrEnvironmentActive = active;
        this.onHdrEnvironmentActiveChanged.invoke(active);
    }
    setDefaultEnvironment(envMap) {
        this.defaultEnvironment = envMap;
    }
    setDefaultBackground(envMap) {
        this.defaultEnvironment = envMap;
    }
    changeToDefaultEnvironment() {
        if (this.defaultEnvironment === undefined)
            return;
        if (this.defaultBackgrund === undefined)
            return;
        mainScene.background = this.defaultBackgrund;
    }
    generateCubeMap(position, params = {}) {
        const resolution = params.resolution !== undefined ? params.resolution : 256;
        const useMipmap = isPowerOfTwo(resolution);
        const cubeRenderTarget = new WebGLCubeRenderTarget(params.resolution !== undefined ? params.resolution : 256, {
            generateMipmaps: useMipmap,
            minFilter: LinearMipmapLinearFilter,
            colorSpace: SRGBColorSpace // since gamma is applied during rendering, the cubeCamera renderTarget texture encoding must be sRGBEncoding
        });
        const cubeCamera = new CubeCamera(params.near !== undefined ? params.near : 1, params.far !== undefined ? params.far : 1000, cubeRenderTarget);
        cubeCamera.layers.set(CameraLayers.Reflection);
        cubeCamera.layers.enable(CameraLayers.Static);
        cubeCamera.position.copy(position);
        cubeCamera.updateMatrixWorld(true);
        cubeCamera.update(cubeMapRenderer, mainScene);
        const vrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const mapping = cubeRenderTarget.texture.mapping;
        const isEquirectMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;
        const pmremGenerator = new PMREMGenerator(renderer);
        const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(cubeRenderTarget.texture) : pmremGenerator.fromCubemap(cubeRenderTarget.texture);
        const envMap = renderTarget.texture;
        renderer.xr.enabled = vrEnabled;
        cubeCamera.renderTarget.dispose();
        if (cubeCamera.parent) {
            cubeCamera.parent.remove(cubeCamera);
        }
        return envMap;
    }
}
export const environmentSceneService = new EnvironmentSceneService();
